<template>
    <footer-default class="footer--basic">
        <slot />
    </footer-default>
</template>

<script>
import FooterDefault from "@/sets/styles/footers/footer-default.vue";

export default {
    props: {},
    components: {
        FooterDefault,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
